import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';
import { debounce } from '../../core/helpers';
import sliderADA from '../../components/slider/ada';

const updateBannerHeight = (sliderEl, isInit = false) => {
  if (window.theme.breakpoints.current === 'mobile') {
    const mainBanners = document.querySelectorAll('.collection-smart-banner .collection-smart-banner__main');
    mainBanners.forEach(el => el.removeAttribute('style'));
    return;
  }

  const firstItem = sliderEl.querySelector('.collection-smart-banner-item');
  const img = firstItem ? firstItem.querySelector('img') : null;

  if (!img) return;

  const applyHeight = () => {
    const first_img_height = img.offsetHeight;
    if (first_img_height > 0) {
      const mainBanners = document.querySelectorAll('.collection-smart-banner .collection-smart-banner__main');
      mainBanners.forEach(el => el.style.height = `${first_img_height}px`);
    }
  };

  // On init, wait for the image to load before measuring to avoid a mid-render shift.
  // On resize, the image is already loaded so we can measure immediately.
  if (isInit) {
    if (img.complete && img.naturalHeight > 0) {
      applyHeight();
    } else {
      img.addEventListener('load', applyHeight);
    }
  } else {
    applyHeight();
  }
};

const initSlider = (sliderEl) => {
  const total_slides = sliderEl.querySelectorAll('.collection-smart-banner-item').length;

  const swiper = new Swiper(sliderEl, {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: total_slides > 3 ? 3.3 : 3,
    slidesPerGroup: 1,
    spaceBetween: 8,
    loop: total_slides > 3,
    loopAddBlankSlides: false,
    autoHeight: false,
    freeMode: true,
    autoplay: false,
    navigation: {
      nextEl: '.collection-smart-banner .swiper-button-next',
      prevEl: '.collection-smart-banner .swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.4,
        slidesPerGroup: 1,
        spaceBetween: 8,
        freeMode: false,
        autoHeight: false,
      },
      990: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 16,
        freeMode: false,
        autoHeight: false,
      },
    },
    on: {
      init: function () {
        updateBannerHeight(sliderEl, true);
        animate();
        sliderADA(document.querySelector('.collection-smart-banner .swiper'));
      },
    }
  });
};

export default () => {
  const banner = document.querySelector('.collection-smart-banner');
  if (!banner) {
    return;
  }

  const slider = banner.querySelector('.swiper');
  if (!slider) {
    return;
  }

  initSlider(slider);

  window.addEventListener('resize', debounce(() => {
    updateBannerHeight(slider);
  }, 10));
};
